/** Hide the untagged 2026-03-12 20:21:31 UTC entry only in the version picker. */
export const HIDDEN_UNTAGGED_SNAPSHOT_ID = '6970853268727142424';
